import React from 'react';
import { FinancialPackLanding } from './pages/FinancialPackLanding';
export function App() {
  return <FinancialPackLanding data-id="element-0" />;
}